module.exports = __webpack_public_path__ + "img/cooperate_process.c3fc84cf.png";